export class HsUser {
  constructor(user) {
    this.connectionId = user.connection_id;
    this.email = user.email;
    this.hsUserId = user.hs_user_id;
    this.portalId = user.portal_id;
    this.token = user.token;
  }
}
